import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter} from 'react-router-dom';
import { UserProvider } from './contexts/user.context';
import './App.css'; // Import global CSS

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
     <BrowserRouter>
         <UserProvider>
            <App />
         </UserProvider>
     </BrowserRouter>
  </React.StrictMode>
);